import { Component, OnInit } from '@angular/core';

import { UtilityService, AuthService, AppInformationService, ArkUnitOfWork } from 'app/core/core.module';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FamiliesDetailComponent } from '../families-detail/families-detail.component';
import { VisitDetailComponent } from '../visit-detail/visit-detail.component';
import { Family } from 'app/core/model/entity-model';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-visit-household',
    templateUrl: './visit-household.component.html',
    styleUrls: ['./visit-household.component.scss'],
    imports: [DevExtremeModule]
})
export class VisitHouseholdComponent implements OnInit {
    households: any;
    filter: any;
    families: any[];
    givingYears: any;
    canPrintStatement = false;

    constructor(
        private uow: ArkUnitOfWork,
        private utility: UtilityService,
        private auth: AuthService,
        private appInfo: AppInformationService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        const relationships = await this.uow.getRelationships();

        this.households = await this.uow.getHouseholds();
        this.filter = { householdId: this.households[0].id };
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async onValueChanged(e) {
        if (!this.filter.householdId) return;
        await this.getData();
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // if (!e.data.days) e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
            if (!!e.data.days || e.data.days === 0) {
                if (e.data.days < 180)
                    e.rowElement.className = e.rowElement.className + ' visits-green-grid';
                if (e.data.days >= 180 && e.data.days < 365)
                    e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
                if (e.data.days >= 365)
                    e.rowElement.className = e.rowElement.className + ' visits-red-grid';
            }
        }
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.families = await this.uow.getHouseholdVisits(this.filter.householdId);
        this.families.forEach((family) => {
            if (!!family.lastVisit) family.lastVisit = moment(family.lastVisit).toDate();
            family.family = family.family as Family;
            const days =  Math.floor(moment.duration(moment(new Date()).diff(family.lastVisit)).asDays());
            family.days = isNaN(days) ? null : days;
        });
        this.appInfo.pleaseWaitHide();
    }

    async addVisit(selectedRow?: any) {
        // console.log(selectedRow);
        const modalRef = this.modalService.show(VisitDetailComponent, {
            class: this.appInfo.graafschap ? 'modal-lgw' : 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                visitId: selectedRow ? selectedRow.lastVisitId : null,
                showAsDialog: true,
                familyId: selectedRow ? selectedRow.id : null
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async quickVisit(selectedRows: any) {
        if (!selectedRows) return;
        const user = this.auth.currentUser.personId;

        const array = selectedRows;
        for (let index = 0; index < array.length; index++) {
            const family = await this.uow.getFamilyById(array[index].id) as Family;

            const visit = this.uow.visits.createEntity() as any;
            visit.personId = family.headOfHousehold.id;
            visit.visitedById = !!user ? user : 3794;
            visit.date = moment(new Date()).startOf('day').toDate();
            visit.notes = `Quick note logged by ${this.auth.currentUser.userName} on ${moment(new Date()).toDate()}`
        }

        await this.uow.commit();
        await this.getData();
    }

    async open(data: any) {
        const modalRef = this.modalService.show(FamiliesDetailComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // family: data.family,
                key: data.id,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // await this.getData();
            }
            modalRef.hide();
        });
    }
}
